export enum RefereeTypeEnum {
  Head = "HEAD",
  Assistant = "ASSISTANT",
  Fourth = "FOURTH",
  Var = "VAR",
  VarAssist = "ASST_VAR",
}
